import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import CircularProgressWithLabel from "./circularProgressWithLabel";

const CustomLoadingOverlay = () => {
  const [progress, setProgress] = useState(10);

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    backgroundColor:
      theme.palette.mode === "light"
        ? "rgba(255, 255, 255, 0.9)"
        : "rgba(18, 18, 18, 0.9)",
  }));

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 0 : prevProgress + 10
      );
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <StyledGridOverlay>
      <CircularProgressWithLabel value={progress} />
      <Box sx={{ mt: 2 }}>Loading rows…</Box>
    </StyledGridOverlay>
  );
};

export default CustomLoadingOverlay;
